import { Component, computed, input, output } from '@angular/core';
import { LanguageCodeHelper } from '@app/app/shared/helpers/language-code-helper';
import { CardUIType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-card-item-list-view',
  templateUrl: './card-item-list-view.component.html',
  styleUrls: ['./card-item-list-view.component.scss'],
})
export class CardItemListViewComponent {
  card = input<PlaylistCardShort>();
  cardType = input<CardUIType>('general');
  cardIndex = input(0);
  showMeta = input(true);
  showReviews = input(true);
  showProgressLine = input(true);

  cardClick = output<PlaylistCardShort>();

  cardSubheader = computed(() => {
    const card = this.card();
    return card?.subHeader ? LanguageCodeHelper.getDataByLanguageCode(card.subHeader).value.trim() : '';
  });
}
